<template>
  <div>
    <section id="sec2" class="pb-0 pt-40">
      <div class="container">
        <div class="section-title">
          <div class="d-flex align-items-center justify-content-between">
            <h2>{{ $t('ui_infoTitle') }}</h2>
            <b-button variant="link" class="p-10" @click="Hide">
              <i class="fas fa-times pl-0"></i>
            </b-button>
          </div>
          <div class="section-subtitle">{{ $t('ui_infoTitleBg') }}</div>
          <span class="section-separator"></span>
        </div>
        <div class="about-wrap">
          <div class="row w-100">
            <div class="col-md-6">
              <div class="video-box fl-wrap">
                <img src="../../assets/images/szemet.jpg" alt="" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="list-single-main-item-title fl-wrap">
                <h3 v-html="$t('ui_infoSubtitle')"></h3>
                <span class="section-separator fl-sec-sep"></span>
              </div>
              <div v-html="$t('ui_infoText')"></div>
            </div>
          </div>
        </div>
        <span class="fw-separator" id="apps"></span>
        <div class="features-box-container fl-wrap row" id="apps">
          <div class="features-box col-md-4">
            <div class="time-line-icon">
              <i class="fas fa-mobile-alt"></i>
            </div>
            <h3 v-html="$t('ui_featureBox1Title')"></h3>
            <p v-html="$t('ui_featureBox1Text')"></p>
          </div>

          <div class="features-box col-md-4">
            <div class="time-line-icon">
              <i class="far fa-file-pdf"></i>
            </div>
            <h3 v-html="$t('ui_featureBox2Title')"></h3>
            <p v-html="$t('ui_featureBox2Text')"></p>
          </div>

          <div class="features-box col-md-4">
            <div class="time-line-icon">
              <i class="fas fa-search-location"></i>
            </div>
            <h3 v-html="$t('ui_featureBox3Title')"></h3>
            <p v-html="$t('ui_featureBox3Text')"></p>
          </div>
        </div>
        <div
          class="list-single-main-item fl-wrap border-0"
          v-html="$t('ui_infoEndText')"
        ></div>
      </div>
    </section>
    <section id="fbvideo" class="pt-0 pb-50">
      <div class="container">
        <iframe
          height="450"
          src="https://www.youtube.com/embed/VFhdw4CusOY"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="w-100"
        ></iframe>
      </div>
    </section>
  </div>
</template>

<script>
import { useModalHandler } from '../../utils/modal';

export default {
  name: 'terkep-info-modal',
  data() {
    return {};
  },
  setup(props, context) {
    let { Hide } = useModalHandler(props, context);
    return { Hide };
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {},
  watch: {},
  props: {},
};
</script>
